import React, { useCallback, useEffect, useState } from 'react';
import * as MinistryReportApi from '../../api/MinistryReportApi';
import MinsitryScatterChart from '../../components/MinistryReport/MinsitryScatterChart';
import { PageBody } from '../../components/SiteWrapper';
import { Card, Col, Row } from 'react-bootstrap';
import { FormFieldSelect } from '../../components/Form/FormField';
import { useForm } from 'react-hook-form';
import moment from 'moment';
import MinistryDonutChart from '../../components/MinistryReport/MinistryDonutChart';
import PageHeaderActions from '../../components/General/PageHeaderActions';
import MinistryBarChart from '../../components/MinistryReport/MinistryBarChart';
import MinistryTypeOfIssueDonut from '../../components/MinistryReport/MinistryTypeOfIssueDonut';
import MinistryStackedChart from '../../components/MinistryReport/MinistryStackedChart';
import { MinistryIncidentCountTable } from '../../components/MinistryReport/MinistryIncidentCountTable';
import * as MinistryExamApi from '../../api/MinistryExams';

const MonitoringReportDashboard = () => {
  const [loading, setLoading] = useState(false);
  const [exams, setExams] = useState([]);

  const { control, watch, setValue } = useForm({
    mode: 'onChange',
    defaultValues: {
      exam: { value: '', label: 'Select Exam' },
      date: { value: '', label: 'Select Exam Date' },
      shift: { value: '', label: 'All Shifts' },
    },
  });

  const [data, setData] = useState([]);
  const [donutChartData, setDonutChartData] = useState([]);
  const [typeWiseData, setTypeWiseData] = useState([]);
  const [barChartData, setBarChartData] = useState([]);
  const [examDates, setExamDates] = useState([]);
  const [filter, setFilter] = useState({ shift: null, date: null, exam: null });
  const [stackedChartData, setStackedChartData] = useState([]);

  const selectedShift = watch('shift');
  const selectedExamDate = watch('date');
  const selectedExam = watch('exam');

  const getExams = async () => {
    const response = await MinistryExamApi.getAll();
    if (response.success) {
      // const examList = response?.data?.records?.map(({ id, exam_name }) => ({
      //   value: id,
      //   label: exam_name,
      // }));
      setExams(response?.data?.records ? response?.data?.records : []);
    }
  };
  useEffect(() => {
    getExams();
  }, []);

  useEffect(() => {
    setFilter({
      shift: selectedShift?.value || null,
      date: selectedExamDate?.value?.date || null,
      exam: selectedExam?.value || null,
    });
  }, [selectedShift, selectedExamDate, selectedExam]);

  useEffect(() => {
    setValue('shift', null);
    setValue('date', null);
  }, [selectedExam]);

  const getData = useCallback(async (activeFilter) => {
    setLoading(true);
    const response = await MinistryReportApi.getReportData(activeFilter);
    if (response.success) {
      if (response?.data?.structuredScatterChartData)
        setData(response?.data?.structuredScatterChartData);
      setDonutChartData(response?.data?.stagesCount);
      setBarChartData(response?.data?.reasonCategoryCount);
      setTypeWiseData(response?.data?.typeCounts);
      setStackedChartData(response?.data?.dateWiseCounts);
      if (response?.data?.dates) {
        setExamDates(
          response?.data?.dates.map((date) => ({
            label: moment(date.date).format('DD/MM/YYYY'),
            value: date,
          }))
        );
      }
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    if (filter.shift !== null || filter.date !== null || filter.exam !== null) {
      getData(filter);
    }
  }, [filter, getData]);
  useEffect(() => {
    getData(filter);
  }, []);

  return (
    <div className='pb-3'>
      <div className='rounded'>
        <div className='d-flex justify-content-between align-items-center'>
          <div className='w-100 '></div>
          <div className='d-flex w-100 justify-content-end gap-3 w-100 pe-3'>
            <FormFieldSelect
              name='exam'
              control={control}
              options={exams.map((exam) => ({
                label: exam.exam_name,
                value: exam.id,
              }))}
              size='3'
              placeholder='Select Exam'
              className='shadow-none m-0'
              isLabel={false}
            />
            <FormFieldSelect
              name='date'
              control={control}
              options={[{ label: 'Select Exam Date', value: '' }, ...examDates]}
              placeholder='Select Exam Date'
              size='3'
              isLabel={false}
              disabled={filter.exam === null}
              className='shadow-none m-0'
            />

            <FormFieldSelect
              name='shift'
              control={control}
              options={[
                { value: null, label: 'All Shifts' },
                { value: 'shift1', label: 'Shift 1' },
                { value: 'shift2', label: 'Shift 2' },
                { value: 'shift3', label: 'Shift 3' },
              ]}
              placeholder='Select Shift'
              className='shadow-none m-0'
              size='2'
              isLabel={false}
            />
          </div>
        </div>
        {/* <hr className='m-0' /> */}
        <div className='p-3'>
          <Card className='shadow-none'>
            <Card.Header className='bg-light-rrb d-flex justify-content-between'>
              <h3 className='fs-16 mb-0 fw-medium'>Stage of Exam</h3>
            </Card.Header>
            <Card.Body className='px-3'>
              <MinistryStackedChart data={stackedChartData} />
            </Card.Body>
          </Card>

          <Card className='mt-3 shadow-none pb-3 border-0'>
            <div className='d-flex flex-column gap-3'>
              <Row className='d-flex' md={12}>
                <Col md={4}>
                  <Card>
                    <Card.Header className='bg-light-rrb d-flex justify-content-between'>
                      <h3 className='fs-16 mb-0 fw-medium'>Stage of Exam</h3>
                    </Card.Header>
                    <Card.Body>
                      <div className='d-flex justify-content-center align-items-center py-3 px-3'>
                        <MinistryDonutChart
                          data={donutChartData}
                          isLoading={loading}
                          selectedDatee={selectedExamDate?.value?.date}
                          selectedShift={selectedShift?.value}
                        />
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
                <Col md={4}>
                  <Card>
                    <Card.Header className='bg-light-rrb d-flex justify-content-between '>
                      <h3 className='fs-16 mb-0 fw-medium'>Reason Category</h3>
                    </Card.Header>
                    <Card.Body>
                      <div className='d-flex justify-content-center align-items-center py-3 px-3'>
                        <MinistryBarChart
                          isLoading={loading}
                          data={barChartData}
                          selectedDatee={selectedExamDate?.value?.date}
                          selectedShift={selectedShift?.value}
                        />
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
                <Col md={4}>
                  <Card>
                    <Card.Header className='bg-light-rrb d-flex justify-content-between'>
                      <h3 className='fs-16 mb-0 fw-medium'>Type Of Issue</h3>
                    </Card.Header>
                    <Card.Body>
                      <div className='d-flex justify-content-center align-items-center py-3 px-3'>
                        <MinistryTypeOfIssueDonut
                          data={typeWiseData}
                          isLoading={loading}
                          selectedDatee={selectedExamDate?.value?.date}
                          selectedShift={selectedShift?.value}
                        />
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>

              <Card>
                <Card.Header className='bg-light-rrb d-flex justify-content-between'>
                  <h3 className='fs-16 mb-0 fw-medium'>Incident Timeline</h3>
                </Card.Header>
                <Card.Body>
                  <MinsitryScatterChart data={data} isLoading={loading} />
                </Card.Body>
              </Card>
            </div>
          </Card>

          <div className=''>
            <Card className='shadow-none'>
              <Card.Header className='bg-light-rrb d-flex justify-content-between'>
                <h3 className='fs-16 mb-0 fw-medium'>Stage of Exam</h3>
              </Card.Header>
              <MinistryIncidentCountTable
                data={stackedChartData}
                isLoading={loading}
              />
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MonitoringReportDashboard;
